/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';

const MarginModalRightSection = ({
  marginOverrideEnabled, toggleMarketOverride, marginOverrideProbabilityThreshold,
  handleOverideProbabilityThresholdChange, marginOverrideTimeSlot, handleMarginOverrideTimeSlot,
}) => (
  <>
    <div className="dialog__row d-flex align-items-center justify-content-between">
      <span className="m-r-15">Margin Override</span>
      <div className="dialog__input-wrap dialog__input-wrap--sm text-center">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={marginOverrideEnabled}
            onChange={toggleMarketOverride}
          />
          {' '}
          <span className="toggle-switch__slider" />
        </label>
      </div>
    </div>
    <div className="dialog__row d-flex m-t-20 align-items-center justify-content-between">
      <span className="m-r-15">Margin Override Probability Threshold</span>
      <div className={`dialog__input-wrap dialog__input-wrap--sm d-flex align-items-center
                  ${!marginOverrideEnabled ? 'dialog__input-wrap--disabled' : ''}`}
      >
        <input
          className="dialog__input text-center"
          type="number"
          min="80"
          max="100"
          disabled={!marginOverrideEnabled}
          value={marginOverrideProbabilityThreshold}
          onChange={handleOverideProbabilityThresholdChange}
        />
        <div className="dialog__input-unit">%</div>
      </div>
    </div>
    <div className="dialog__row d-flex m-t-20 align-items-center justify-content-between">
      <span className="m-r-15">Margin Override Time Slot</span>
      <div className={`dialog__input-wrap dialog__input-wrap--sm
                   ${!marginOverrideEnabled ? 'dialog__input-wrap--disabled' : ''}`}
      >
        <input
          className="dialog__input text-center"
          type="number"
          min="1"
          max="90"
          value={marginOverrideTimeSlot}
          onChange={handleMarginOverrideTimeSlot}
          disabled={!marginOverrideEnabled}
        />

      </div>
    </div>
  </>
);

export default MarginModalRightSection;
